import React from "react";
import { Reveal, Eyebrow } from "./Decorative";

/**
 * Dark banner used at the top of interior pages. Clears the fixed nav and
 * gives each page a consistent eyebrow / H1 / intro structure.
 */
export default function PageHero({ eyebrow, title, intro, children }) {
  return (
    <section
      className="relative px-5 pt-32 md:pt-40 pb-14 md:pb-20 overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse at 50% -10%, rgba(201,169,97,0.16) 0%, transparent 55%), linear-gradient(180deg,#0F0A07 0%,#1C1A17 100%)",
      }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h1
            className="mt-4 font-display leading-[1.02] tracking-tight"
            style={{ color: "#FBF6EE", fontSize: "clamp(2.2rem, 6vw, 4rem)" }}
          >
            {title}
          </h1>
          {intro && (
            <p className="mt-6 font-body text-base md:text-lg leading-relaxed" style={{ color: "#E8D9C5" }}>
              {intro}
            </p>
          )}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
